import React from 'react';
import { makeStyles } from 'src/makeStyles';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import { colors, fontSize } from '../../constants/styleConstants';

const useStyles = makeStyles()((theme, props) => ({
  paper: {
    position: 'absolute',
    width: props.isMedia ? '80vw' : '50vw',
    height: 'auto',
    backgroundColor: theme.palette.background.paper,
    border: 0,
    boxShadow: theme.shadows[5],
    padding: 0,
    top: '50%',
    left: '50%',
    transform: `translate(-50%, -50%)`,
    outline: 'none',
    [theme.breakpoints.down('md')]: {
      width: '100% !important',
      height: '100%',
    },
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    '&:focus': {
      outline: 'none',
    },
  },
  closeIcon: {
    position: 'absolute',
    padding: 0,
    zIndex: 2,
    top: '1px',
    right: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    background: colors.white,
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
      backgroundColor: colors.white,
    },
  },
  mediaCloseIcons: {
    top: '20px',
    right: '20px',
    width: '18px',
    height: '18px',
  },
  transparentClose: {
    background: 'none',
    cursor: 'pointer',
    '&:hover': {
      opacity: 1,
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
    },
  },
  closeSize: {
    fontSize: fontSize.basic,
    fontStyle: 'bold',
  },
}));

const SimpleModal = props => {
  const {
    isModalOpen,
    onClose,
    children,
    className,
    hideCloseIcon,
    contentClassName,
    transparentClose,
    disableBackdropClick,
    disableEscapeKeyDown,
    ...rest
  } = props;
  const { classes, cx } = useStyles(props);

  const handleClose = (event, reason) => {
    if (disableBackdropClick && reason === 'backdropClick') {
      return false;
    }

    if (disableEscapeKeyDown && reason === 'escapeKeyDown') {
      return false;
    }

    if (typeof onClose === 'function') {
      onClose(event, reason);
    }
    return false;
  };

  return (
    <Modal
      open={isModalOpen}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      {...rest}
    >
      <div className={cx(classes.paper, className)}>
        {!hideCloseIcon && (
          <IconButton
            className={cx(classes.closeIcon, {
              [classes.transparentClose]: transparentClose,
              [classes.mediaCloseIcons]: props.isMedia,
            })}
            onClick={onClose}
            size="large"
          >
            <CloseIcon className={classes.closeSize} />
          </IconButton>
        )}
        <div className={contentClassName || classes.content}>{children}</div>
      </div>
    </Modal>
  );
};

SimpleModal.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  hideCloseIcon: PropTypes.bool,
  isMedia: PropTypes.bool,
  disableBackdropClick: PropTypes.bool,
  disableEscapeKeyDown: PropTypes.bool,
};

export default SimpleModal;
